export default {"src":"/_next/static/media/7.c2757152.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};